import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { compose } from 'redux';
import { Flex } from 'nallian-shared-ui/lib/components';
import HostsForm from './HostsForm';
import hostsService from '../../services/hosts/hostsService';
import updateHostsService from '../../services/hosts/updateHostsService';

const Hosts = ({ dispatchHostsGet, hostsFetch, dispatchUpdateHostsPut, updateHostsFetch }) => {
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => dispatchHostsGet(id), [dispatchHostsGet, id]);

  const handleSaveHosts = useCallback(values => dispatchUpdateHostsPut(id, values, t), [
    id,
    dispatchUpdateHostsPut,
    t,
  ]);

  return (
    <Flex fluid>
      <HostsForm
        loading={hostsFetch.pending}
        submitting={updateHostsFetch.pending}
        initialValues={{ hosts: hostsFetch.value || [] }}
        onSubmitForm={handleSaveHosts}
      />
    </Flex>
  );
};

Hosts.propTypes = {
  dispatchHostsGet: PropTypes.func.isRequired,
  hostsFetch: PropTypes.object.isRequired,
  dispatchUpdateHostsPut: PropTypes.func.isRequired,
  updateHostsFetch: PropTypes.object.isRequired,
};

export default compose(hostsService, updateHostsService)(Hosts);
